"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformMeetingSettingsErrors = exports.transformGetSettingsResponseToPayload = exports.transformProfileSettingsResponseToErrors = exports.transformAvailablePeriodsToRequest = exports.transformSlot = exports.getEmptySlot = exports.availableDays = exports.groupByDayType = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _uuid = require("uuid");

var _ramda = require("ramda");

var _personalProfileSettings = require("./personalProfileSettings.contants");

var groupByDayType = (0, _ramda.groupBy)((0, _ramda.prop)('day'));
exports.groupByDayType = groupByDayType;
var availableDays = (0, _ramda.pipe)((0, _ramda.slice)(1, Infinity), (0, _ramda.append)(_moment.default.weekdays(0)), (0, _ramda.addIndex)(_ramda.map)(function (day, index) {
  return {
    id: index + 1,
    dayName: day
  };
}))(_moment.default.weekdays());
exports.availableDays = availableDays;

var getEmptySlot = function getEmptySlot(day) {
  return {
    id: (0, _uuid.v4)(),
    day,
    from: (0, _ramda.clone)(_personalProfileSettings.DEFAULT_START_OF_THE_DAY),
    till: (0, _ramda.clone)(_personalProfileSettings.DEFAULT_END_OF_THE_DAY)
  };
};

exports.getEmptySlot = getEmptySlot;

var transformSlot = function transformSlot(slot) {
  return {
    id: (0, _uuid.v4)(),
    day: slot.day,
    from: (0, _moment.default)(slot.from, _moment.default.HTML5_FMT.TIME_SECONDS),
    till: (0, _moment.default)(slot.till, _moment.default.HTML5_FMT.TIME_SECONDS)
  };
};

exports.transformSlot = transformSlot;
var getEnabledDays = (0, _ramda.filter)((0, _ramda.propEq)('enabled', true));
var transformAvailablePeriodsToRequest = (0, _ramda.pipe)(getEnabledDays, (0, _ramda.map)((0, _ramda.prop)('slots')), _ramda.values, _ramda.flatten, (0, _ramda.map)(function (_ref) {
  var day = _ref.day,
      till = _ref.till,
      from = _ref.from;
  return {
    day,
    till: till.format('HH:mm:ss'),
    from: from.format('HH:mm:ss')
  };
}));
exports.transformAvailablePeriodsToRequest = transformAvailablePeriodsToRequest;
var transformProfileSettingsResponseToErrors = (0, _ramda.applySpec)({
  currentPassword: (0, _ramda.prop)('current_password'),
  newPassword: (0, _ramda.prop)('new_password'),
  newPasswordConfirmation: (0, _ramda.prop)('new_password_confirmation'),
  calendarPeriods: (0, _ramda.prop)('availability_periods')
});
exports.transformProfileSettingsResponseToErrors = transformProfileSettingsResponseToErrors;
var transformGetSettingsResponseToPayload = (0, _ramda.applySpec)({
  countryId: (0, _ramda.prop)('country_id'),
  currencyId: (0, _ramda.prop)('currency_id'),
  isUnsubscribed: (0, _ramda.prop)('is_unsubscribed'),
  hideBusyCalendarPeriods: (0, _ramda.path)(['meeting_settings', 'hide_busy_calendar_periods']),
  bufferTimeInMinutes: (0, _ramda.path)(['meeting_settings', 'meeting_config', 'buffer_time_in_minutes']),
  meetingDuration: (0, _ramda.path)(['meeting_settings', 'meeting_config', 'duration']),
  meetingFrequency: (0, _ramda.path)(['meeting_settings', 'meeting_config', 'frequency']),
  autoSendMeetingInviteToRecipient: (0, _ramda.path)(['meeting_settings', 'meeting_config', 'auto_send_meeting_invite_to_recipient']),
  meetingLimits: {
    startIn: (0, _ramda.path)(['meeting_settings', 'meeting_limits', 'start_in']),
    finishIn: (0, _ramda.path)(['meeting_settings', 'meeting_limits', 'finish_in'])
  },
  meetingPlace: {
    additionalInfo: (0, _ramda.path)(['meeting_settings', 'place', 'additional_info']),
    place: (0, _ramda.path)(['meeting_settings', 'place', 'place'])
  },
  calendarTimezone: (0, _ramda.path)(['meeting_settings', 'timezone']),
  calendarPeriods: (0, _ramda.pipe)((0, _ramda.pathOr)([], ['meeting_settings', 'availability_periods']), (0, _ramda.map)(transformSlot), function (periods) {
    var groupedDays = groupByDayType(periods);
    return (0, _ramda.map)(function (_ref2) {
      var id = _ref2.id,
          dayName = _ref2.dayName;
      var hasSlots = !!(groupedDays[id] && groupedDays[id].length);
      var slots = (0, _ramda.propOr)([getEmptySlot(id)], id)(groupedDays);
      return {
        id,
        dayName,
        enabled: hasSlots,
        slots
      };
    })(availableDays);
  })
});
exports.transformGetSettingsResponseToPayload = transformGetSettingsResponseToPayload;
var transformMeetingSettingsErrors = (0, _ramda.applySpec)({
  bufferTimeInMinutes: (0, _ramda.prop)('buffer_time_in_minutes')
});
exports.transformMeetingSettingsErrors = transformMeetingSettingsErrors;